const utente = {
    getRuolo: function (atleti, atleta_id) {
        if (!atleta_id) return false;
        let atleta = atleti.find((el) => (el.atleta_id == atleta_id));
        if (!atleta) return false;
        return atleta.ruolo_codice;
    },

    isRuoloAllenatore: function (atleti, atleta_id) {
        const ruolo_codice = utente.getRuolo(atleti, atleta_id);
        if (!ruolo_codice) return false;
        if (ruolo_codice == 'allenatore') {
            return true;
        } else {
            return false;
        }
    },

    canEdit: function (item) {
        return item.is_editable;
    },
};

export {utente as default};
